import {
    ADD_OEM_REQUEST,
    ADD_OEM_RESULT,
    ADD_OEM_OPEN_MODAL,
    ADD_OEM_CLOSE_MODAL,
    ADD_OEM_GET_INTEGRATIONS_REQUEST,
    ADD_OEM_GET_INTEGRATIONS_RESULT,
    ADD_OEM_SET_INTEGRATIONS,
} from 'Redux/actionTypes';

export const addOemRequest = (data) => ({
    type: ADD_OEM_REQUEST,
    payload: data
})

export const addOemResult = (result) => ({
    type: ADD_OEM_RESULT,
    payload: result
})

export const addOemOpenModal = (data) => ({
    type: ADD_OEM_OPEN_MODAL,
    payload: data
})

export const addOemCloseModal = () => ({
    type: ADD_OEM_CLOSE_MODAL
})

export const addOemGetIntegrationsRequest = (item, accountId) => ({
    type: ADD_OEM_GET_INTEGRATIONS_REQUEST,
    payload: { devices: item, accountId: accountId }
})

export const addOemGetIntegrationsResult = (result) => ({
    type: ADD_OEM_GET_INTEGRATIONS_RESULT,
    payload: result
})

export const addOemSetDevice = (device) => ({
    type: ADD_OEM_SET_INTEGRATIONS,
    payload: device
})